import { Component, OnInit, ViewChild, Injector } from '@angular/core';
import { ManageLineService } from 'src/app/services/manage-line.service';
import { UntypedFormControl } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { isNullOrUndefined } from 'src/app/services/utils';
import { NgbModal, NgbModalOptions, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { SuccessComponent } from '../success/success.component';
import { ExportService } from 'src/app/services/export.service';
import {
  MANAGE_MODAL_CONST, MANAGE_LINE_CONST,
  COMMON_CONSTANTS, SUSPEND_CONSTANTS, BULK_UPLOAD, VALUE, ENTITLEMENT_ACTIVITYNAMES, ANALYTICS
} from '../../../common/core/common.constants';
import { IndividualLineHeaders, MultiLineHeaders, Requests } from '../../../common/models/data.model';
import { HttpCacheService } from 'src/app/services/http-cache.service';
import { UtilsService } from 'src/app/services/utils.service';
import { LoaderService } from 'src/app/services/loader.service';
import { DateFormatService } from 'src/app/services/date-format.service';
import { ContentService } from 'src/app/services/content.service';
import { environment } from 'src/environments/environment';
import { HelperUtilityService } from 'src/app/services/helper-utility.service';
import { PDLService } from 'src/app/services/pdl-service.service';
@Component({
  selector: 'app-suspend',
  templateUrl: './suspend.component.html',
  styleUrls: ['./suspend.component.scss'],
  providers: [
    { provide: NgbDateParserFormatter, useClass: DateFormatService },
  ],
})
export class SuspendComponent implements OnInit {

  @ViewChild('ngxdp') ngxdp;
  @ViewChild('dp') datePicker;
  public reasons: any;
  public approverTypeList: any;
  selectedLines: any;
  reasonForChanges: any;
  selectedReason: any;
  reasonFormGroup: any;
  approverType: any;
  endDate: any;
  startDate: any;
  calendar: any;
  suspendendeLines: any = [];
  uniqueReasonsSelected: any;
  suspendHeader: any;
  applyToAll: any;
  selectsubmitCheckBox = false;
  checkBoxDisabled = true;
  succesValidator = false;
  errorValidator = false;
  msgShowOnPanel = false;
  termsAndConditionCheckBox = true;
  checkboxDisable = true;
  tncCheckboxDisable = true;
  tncCheckBox = true;
  suspendedReasons: any;
  suspendedApprovalTypes: any;
  IndividualLine: any;
  individualLineHeaders: IndividualLineHeaders = new IndividualLineHeaders();
  multiLineHeaders: MultiLineHeaders = new MultiLineHeaders();
  ban: any;
  dealerCode: any;
  requestHeaders: any;
  isOneLine = false;
  multipleLineCounterSuccess: any = 0;
  authoringContentData: any;
  minimumDate: any;
  counter: any = 0;
  bsConfig = {
    showWeekNumbers: false
  };
  susEligibilityerroeInline: any;
  resonErrorInline: any;
  aproverErrorInline: any;
  isLoaderOn = false;
  elstConstant = MANAGE_LINE_CONST.ELST;
  ssqConstant = MANAGE_LINE_CONST.SSQ;
  tmpsConstant = MANAGE_LINE_CONST.TMPS;
  edusConstant = MANAGE_LINE_CONST.EDUS;
  imsConstant = MANAGE_LINE_CONST.IMS;
  mimsConstant = MANAGE_LINE_CONST.MIMS;
  rsqConstant = MANAGE_LINE_CONST.RSQ;
  rssConstant = MANAGE_LINE_CONST.RSS;
  suncConstant = MANAGE_LINE_CONST.SUNC;
  retnConstant = SUSPEND_CONSTANTS.RETENTION_SUSPEND;
  lineApproverType: any;
  reasonForChange: any;
  results: any;
  panelOpenState = false;
  nonActiveLines = [];
  minimumEndDate: any;
  orgId: any;
  maxDate: any;
  isResellerSingleLine: boolean = false;
  maxStartDate: any;
  isSingleFlow: boolean = false;
  finaljsonObj: any;
  disableApplyToAll: any = true;
  isLineDetailsWindow:boolean;
  isApprovalRequired: any;
  approvalActivitiesList: any;
  isAmOktaEnabled: boolean;
  disableSubmit_ForCareUser: boolean= false;
  ngbModalOptions: NgbModalOptions;
  selectedBanDetails: any;
  accountType: any;

  manageLineService: ManageLineService;
  datePipe: DatePipe;
  _helperUtilSvc: HelperUtilityService;
  modalService: NgbModal;
  exportSvc: ExportService;
  _cacheSvc: HttpCacheService;
  utilsSvc: UtilsService;
  _loaderSvc: LoaderService
  pdlService: PDLService;
  PSTDate: any[] = [];
  constructor(private injector : Injector) {
    this.manageLineService = this.injector.get<ManageLineService>(ManageLineService);
    this.datePipe = this.injector.get<DatePipe>(DatePipe);
    this._helperUtilSvc = this.injector.get<HelperUtilityService>(HelperUtilityService);
    this.modalService = this.injector.get<NgbModal>(NgbModal);
    this.exportSvc = this.injector.get<ExportService>(ExportService);
    this._cacheSvc = this.injector.get<HttpCacheService>(HttpCacheService);
    this.utilsSvc = this.injector.get<UtilsService>(UtilsService);
    this._loaderSvc = this.injector.get<LoaderService>(LoaderService);
    this.pdlService = this.injector.get<PDLService>(PDLService);

    this.isLineDetailsWindow = false;
    this.isAmOktaEnabled = this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.AUTH_TYPE) !== COMMON_CONSTANTS.IAM_KEY;
  }

  ngOnInit() {
    this.authoringContentData = this.utilsSvc.getContentDataFromSession();
    this.selectedBanDetails = JSON.parse(this._cacheSvc.getFromSessionStorage(MANAGE_LINE_CONST.SELECTED_BAN_DETAIL));
    this.accountType = this.selectedBanDetails?.accountType || '';
    this.succesValidator = true;
    this.endDate = '';
    this.startDate = '';
    this.minimumEndDate = this.startDate;
    this.suspendendeLines = [];
    this.PSTDate = this.utilsSvc.getMaxMinDates();
    this.updateMinMaxDate();
    this.suspendHeader = !isNullOrUndefined(this.authoringContentData) && !isNullOrUndefined(this.authoringContentData.manageLine) ?
      this.authoringContentData.manageLine.suspendSingleLineHeader : '';
    this.susEligibilityerroeInline = '';
    this.resonErrorInline = '';
    this.aproverErrorInline = '';
    this.multipleLineCounterSuccess = 0;
    this.orgId = this._helperUtilSvc.getOrgID();
    if (this.selectedLines && this.selectedLines.length > 0) {
      for (const line of this.selectedLines) {
        if (line.statusCode !== SUSPEND_CONSTANTS.ACTIVE) {
          this.nonActiveLines.push(line);
        } else {
          line.tncCheckboxDisable = true;
          line.expandFlagValue = false;
          this.suspendendeLines.push(line);
        }
      }
      this.settingMsgHeader();
    }
    this.verifyIsSingleFlow();
    this.disableSubmit_ForCareUser = this.utilsSvc.isReadOnly_AhubCare_UserActivity(ENTITLEMENT_ACTIVITYNAMES.SUSPEND_SINGLE);
    this.resettingAllValues();
    this.getSuspendedReasons();
    if (this.suspendendeLines[0]) {
      this.suspendendeLines[0].expandFlagValue = true;
    }
    this.pdlService.ifEnabledGenerateModalViewTag({
      eventAction: ANALYTICS.LOAD,
      modalName: ANALYTICS.SUSPEND_MODAL_NAME,
    });
  }

  updateMinMaxDate(){
    if (this.PSTDate?.length) {
      this.minimumDate = this.PSTDate[0];
      this.maxDate = this.PSTDate[1];
    }
  }

  verifyIsSingleFlow(){
    if (!isNullOrUndefined(this.suspendendeLines) && this.suspendendeLines.length === 1) {
      this.isSingleFlow = true;
    } else {
      this.isSingleFlow = false;
    }
  }

  checkingMaxDate(line) {
    if (line.reasonForChanges.code === SUSPEND_CONSTANTS.SUSPEND_WITHOUT_CHARGES ||
      line.reasonForChanges.code === SUSPEND_CONSTANTS.SUSPEND_WITH_CHARGES) {
      const currentDate = new Date();
      line.maxStartDate = {
        year: currentDate.getFullYear() + 1, month: currentDate.getMonth() + COMMON_CONSTANTS.DIGITS.ONE,
        day: currentDate.getDate()
      };
    } else {
      line.maxStartDate = undefined;
    }
  }

  settingMsgHeader() {
    if (!this.isSingleFlow) {
      this.suspendendeLines[0].expendFlagValue = true;
      this.suspendHeader = this.authoringContentData.manageLine.suspendMultiLineHeader;
    } else {
      this.suspendHeader = this.authoringContentData.manageLine.suspendSingleLineHeader;
    }

  }

  selectReason(reason) {
    this.pdlService.ifEnabledGenerateClickTag({
      type: ANALYTICS.CLICK_TO_ACTION,
      action: ANALYTICS.CLICK,
      ctaName: ANALYTICS.REASON_FOR_CHANGE,
      assetType: ANALYTICS.DROPDOWN,
      modalName: ANALYTICS.SUSPEND_MODAL_NAME
    });
    this.tncCheckBox = true;
    this.selectsubmitCheckBox = false;
    this.reasonForChanges = reason;
    this.startDate = null;
    this.endDate = null;
    this.applyToAll = false;
    this.disableApplyToAll = true;
    if (!isNullOrUndefined(reason && reason.code) && (reason.code === MANAGE_LINE_CONST.ELST || reason.code === SUSPEND_CONSTANTS.RETENTION_SUSPEND)
      && !isNullOrUndefined(this.suspendendeLines)) {
      this.endDate = '';
      this.minimumEndDate = this.startDate;
      if (this.isSingleFlow) {
        // this.isResellerSingleLine
        const line = this.suspendendeLines[0];
        this.mapSuspendSingleLine(line,reason);
      } else {
        this.disableApplyToAll = false;
        this.approverTypeList = [];
        this.approverType = '';
      }
    } else {
      if (this.isSingleFlow) {
        this.suspendendeLines[0].reasonForChanges = reason;
      }
      this.endDate = '';
      this.minimumEndDate = this.startDate;
      this.getSuspendedApprovalTypes(reason);
    }

    if (reason.code === SUSPEND_CONSTANTS.SUSPEND_WITHOUT_CHARGES ||
      reason.code === SUSPEND_CONSTANTS.SUSPEND_WITH_CHARGES) {
      const currentDate = new Date();
      this.maxStartDate = {
        year: currentDate.getFullYear() + 1, month: currentDate.getMonth() + COMMON_CONSTANTS.DIGITS.ONE,
        day: currentDate.getDate()
      };
    } else {
      this.maxStartDate = undefined;
    }
  }
  mapSuspendSingleLine(line,reason){
    if (!isNullOrUndefined(line)) {
      line.reasonForChanges = reason;
      line.reasonForChange = new UntypedFormControl(reason.description);
      line.lineApproverType = new UntypedFormControl('');
      line.approverType = '';
      line.startDate = null;
      line.endDate = null;
      this.startDate = '';
      this.endDate = '';
      this.approverTypeList = [];
      this.approverType = '';
      this.tncCheckBox = false;

      this.getSuspensionEligibility(line, reason.code, '');
    }
  }
  mapApplyToAllSuspendLines(reason){
    for (const line of this.suspendendeLines) {
      if (!isNullOrUndefined(line)) {
        line.reasonForChanges = reason;
        line.approverType = '';
        line.reasonForChange = new UntypedFormControl(reason.description);
        line.lineApproverType = new UntypedFormControl('');
        line.startDate = null;
        line.endDate = null;
        this.checkingMaxDate(line);
      }
    }
  }
  changeApproverType(reasonCode, approverType) {
    this.approverType = approverType;
    this.endDate = '';
    this.applyToAll = false;
    this.minimumEndDate = this.startDate;
    if (!this.isSingleFlow && !isNullOrUndefined(this.applyToAll) && this.applyToAll) {
      this.applyToAllCheckBox();
    }
    this.disableApplyToAll = true;
  }
   getEndDaysFromReasonCodeAndApproverType(reasonCode, approverTypeCode){
    if (reasonCode && approverTypeCode?.code) {
      if (reasonCode === SUSPEND_CONSTANTS.TEMP_SUSPEND) {
        switch (approverTypeCode.code) {
          case SUSPEND_CONSTANTS.APPROVER_TYPES.SR_MANAGER:
            return COMMON_CONSTANTS.DIGITS.FOURTEEN;
          case SUSPEND_CONSTANTS.APPROVER_TYPES.DIRECTOR_AND_VP:
            return COMMON_CONSTANTS.DIGITS.THIRTY;
          case SUSPEND_CONSTANTS.APPROVER_TYPES.SALES_VP_AND_QA_TEAM:
            return COMMON_CONSTANTS.DIGITS.NINTY;
        }

      }
      switch (reasonCode) {
        case SUSPEND_CONSTANTS.SUSPEND_WITHOUT_CHARGES:
        case SUSPEND_CONSTANTS.SUSPEND_WITH_CHARGES:
          switch (approverTypeCode.code) {
            case SUSPEND_CONSTANTS.APPROVER_TYPES.SALES_REP_INITIATED:
              return COMMON_CONSTANTS.DIGITS.THIRTY;
            case SUSPEND_CONSTANTS.APPROVER_TYPES.B2B_MARKETING_MANAGER:
            case SUSPEND_CONSTANTS.APPROVER_TYPES.SALES_DIRECTOR:
            case SUSPEND_CONSTANTS.APPROVER_TYPES.CUSTOMER_INITIATED:
              return COMMON_CONSTANTS.DIGITS.SIXTY;
            case SUSPEND_CONSTANTS.APPROVER_TYPES.VP:
              return COMMON_CONSTANTS.DIGITS.NINTY;
          }
          break;
        case SUSPEND_CONSTANTS.SEASONAL_SUSPEND:
          return COMMON_CONSTANTS.DIGITS.NINTY;
        case SUSPEND_CONSTANTS.LOST_STOLEN_SUSPEND:
        case SUSPEND_CONSTANTS.RETENTION_SUSPEND:
          return COMMON_CONSTANTS.DIGITS.ZERO;
        case SUSPEND_CONSTANTS.EDUCATION_SUMMER_SUSPEND:
          return COMMON_CONSTANTS.DIGITS.SIXTY;
        case SUSPEND_CONSTANTS.MCSA_CONTRACTUAL_SUSPEND:
          return COMMON_CONSTANTS.DIGITS.NINTY;
        case SUSPEND_CONSTANTS.SUNC_SUSPEND:
          return COMMON_CONSTANTS.DIGITS.ONE_HUNDRED_YEARS_IN_DAYS; //approximately 100 years i.e 36500 days
        case SUSPEND_CONSTANTS.IMPLEMENTATION_SUSPEND:
          switch (approverTypeCode.code) {
            case SUSPEND_CONSTANTS.APPROVER_TYPES.SR_MANAGER:
              return COMMON_CONSTANTS.DIGITS.THIRTY;
            case SUSPEND_CONSTANTS.APPROVER_TYPES.DIRECTOR:
              return COMMON_CONSTANTS.DIGITS.SIXTY;
            case SUSPEND_CONSTANTS.APPROVER_TYPES.VP:
              return COMMON_CONSTANTS.DIGITS.NINTY;
          }
          break;
        default:
          return COMMON_CONSTANTS.DIGITS.ZERO;
      }
    }
    return COMMON_CONSTANTS.DIGITS.ZERO;
  }
  // on select of end date from accordian

  multipleEndDateSelected(line) {
    this.applyToAll = false;
    this.setMessageForPanel(line);
    this.getSuspensionEligibility(line, line.reasonForChanges.code, line.approverType.code);
  }

  // message setting for displaying on panel after close
  setMessageForPanel(line) {
    line.reasonForChangesMsgOnPanel = line.reasonForChanges;
    if (!isNullOrUndefined(line) && !isNullOrUndefined(line.startDate) && line.startDate !== '') {
      line.startDateForamted = new Date(line.startDate.year, line.startDate.month - 1, line.startDate.day);
    } else {
      line.startDateForamted = new Date(this.PSTDate[0].year, this.PSTDate[0].month - 1, this.PSTDate[0].day);
    }
  }

  removeNumber(line) {
    const index = this.suspendendeLines.indexOf(line);
    this.suspendendeLines.splice(index, 1);
    this.manageLineService.changeCurrentSelection(line);
    if (this.multipleLineCounterSuccess !== 0) {
      this.multipleLineCounterSuccess--;
    }
    if (this.suspendendeLines.length === 0) {

      this.manageLineService.close();
    } else {
      this.settingMsgHeader();
      if (this.checkingAllFieldConditionWithAcord()) {
        if (this.suspendendeLines.length === 1) {
          this.termsAndConditionCheckBox = true;
        } else if (!isNullOrUndefined(this.suspendendeLines) && this.multipleLineCounterSuccess === this.suspendendeLines.length) {
          this.termsAndConditionCheckBox = true;
        } else {
          this.termsAndConditionCheckBox = false;
        }
      }
    }
    this.validateTncCheckbox();
  }

  // on change of reason pop on accordian
  onChangeReasonForMultiple(line, reason) {
    this.counter = 0;
    this.tncCheckBox = true;
    if (reason.code === MANAGE_LINE_CONST.ELST || reason.code === SUSPEND_CONSTANTS.RETENTION_SUSPEND) {
      this.tncCheckBox = false;
    } else {
      this.selectsubmitCheckBox = false;
    }
    line.reasonForChanges = reason;
    line.startDate = null;
    this.applyToAll = false;

    line.reasonForChange = new UntypedFormControl(reason.description);
    this.checkingMaxDate(line);
    if (!isNullOrUndefined(reason && reason.code) && (reason.code === MANAGE_LINE_CONST.ELST || reason.code === SUSPEND_CONSTANTS.RETENTION_SUSPEND)) {
      if (!isNullOrUndefined(line)) {
        line.approverType = '';
        line.lineApproverType = new UntypedFormControl('');
        line.startDate = null;
        line.endDate = null;
        line.approverTypeList = [];
        this.getSuspensionEligibility(line, reason.code, '');
        this.setMessageForPanel(line);
      }
    } else {
      this.manageLineService.suspendApprovalTypes(reason.code).subscribe(approvalTypes => {
        if (!isNullOrUndefined(approvalTypes)) {
          line.approverTypeList = approvalTypes.approverTypes;

          this.callsWhenSingleFlow(approvalTypes);
          line.approverType = line.approverTypeList[0];
          line.lineApproverType = new UntypedFormControl(line.approverTypeList[0].description);
          this.callsWhenDateNull(line);
        }
      });
    }
  }

  callsWhenSingleFlow(approvalTypes){
    if(this.isSingleFlow) {
      this.approverType = approvalTypes.approverTypes[0];
    }
  }

  callsWhenDateNull(line){
    if (isNullOrUndefined(line.startDate) || isNullOrUndefined(line.endDate)) {
      line.succesValidator = false;
      line.errorValidator = false;
    }
  }

  changeApproverTypeForMultiple(line, approverType) {
    this.applyToAll = false;

    line.approverType = approverType;
    line.lineApproverType = new UntypedFormControl(approverType.description);
  }

  downloadSpreadsheet() {
    let temp1;
    const changePhoneTemplate = [];
    if (this.isSingleFlow) {
      this.suspendendeLines[0].reasonForChanges = this.reasonForChanges;
      this.suspendendeLines[0].approverType = this.approverType;
    }
    for(let suspendedLine of this.suspendendeLines) {
      if (suspendedLine) {
        temp1 = this.getChangePhoneLineData(suspendedLine);
        changePhoneTemplate.push(temp1);
      }
    }
    this.exportSvc.exportAsExcelFile(changePhoneTemplate, SUSPEND_CONSTANTS.SUSPEND_TEMPLATE_FILE_NAME);
  }

  getChangePhoneLineData(suspendedLine) {
    let suspendStartDate = '';
    let suspendEndDate = '';
    if (suspendedLine.startDate && suspendedLine.startDate.year
      && suspendedLine.startDate.month && suspendedLine.startDate.day) {
      suspendStartDate = this.datePipe.transform(new Date(suspendedLine.startDate.year,
        suspendedLine.startDate.month - 1, suspendedLine.startDate.day), MANAGE_MODAL_CONST.DATE_FORMAT);
    }
    if (suspendedLine.endDate && suspendedLine.endDate.year
      && suspendedLine.endDate.month && suspendedLine.endDate.day) {
      suspendEndDate = this.datePipe.transform(new Date(suspendedLine.endDate.year,
        suspendedLine.endDate.month - 1, suspendedLine.endDate.day), MANAGE_MODAL_CONST.DATE_FORMAT);
    }

    return {
      PhoneNumber: !isNullOrUndefined(suspendedLine.msisdn) ? suspendedLine.msisdn : '',
      SuspendReason: !isNullOrUndefined(suspendedLine.reasonForChanges) ? suspendedLine.reasonForChanges.description : '',
      Suspend_Start_Date: suspendStartDate,
      Suspend_End_Date: suspendEndDate
    };
  }


  // when expansion panel is closed showing message on accordian
  expansionPanelClosed(line) {
    line.msgShowOnPanel = true;
    line.expendFlagValue = false;
  }
  // when expansaion panel is open hiding message accordian
  expansionPanelOpened(line) {
    line.msgShowOnPanel = false;
    line.expendFlagValue = true;
  }
  // method for setting step for accordian
  setStep(i) {
    this.manageLineService.setStep(i);
  }

  // All field condition with accordian
  checkingAllFieldConditionWithAcord() {
    let flag = true;
    for (const line of this.suspendendeLines) {
      if (isNullOrUndefined(line.reasonForChanges) || isNullOrUndefined(line.approverType) ||
        isNullOrUndefined(line.startDate) || isNullOrUndefined(line.endDate) || line.startDate === '' ||
        line.endDate === '' || line.reasonForChanges === '' || line.approverType === '') {
        flag = false;
        break;
      }
    }
    return flag;
  }

  // all field condition without accordian

  checkingAllFieldCondition() {
    let checkingApplyAllField = false;
    if (!isNullOrUndefined(this.reasonForChanges) && !isNullOrUndefined(this.approverType) &&
      !isNullOrUndefined(this.startDate) && !isNullOrUndefined(this.endDate) && this.startDate !== '' &&
      this.endDate !== '' && this.reasonForChanges !== '') {
      checkingApplyAllField = true;
    }

    if (!isNullOrUndefined(this.reasonForChanges) && (this.reasonForChanges.code === MANAGE_LINE_CONST.ELST || this.reasonForChanges.code === SUSPEND_CONSTANTS.RETENTION_SUSPEND)) {
      checkingApplyAllField = true;
    }
    if (!isNullOrUndefined(this.reasonForChanges) && !isNullOrUndefined(this.approverType) &&
    !isNullOrUndefined(this.startDate) && this.reasonForChanges.code === MANAGE_LINE_CONST.SUNC) {
      checkingApplyAllField = true;
    }
    return checkingApplyAllField;
  }
  // when apply all checkbox is clicked
  applyToAllCheckBox() {
    if (!isNullOrUndefined(this.applyToAll) && this.applyToAll) {
      this.disableApplyToAll = true;
      if (this.endDate === '') {
        this.selectsubmitCheckBox = false;
        this.tncCheckBox = true;
      }
      const checkingApplyAllField = this.checkingAllFieldCondition();
      if (!isNullOrUndefined(this.reasonForChanges) && (this.reasonForChanges.code === MANAGE_LINE_CONST.ELST || this.reasonForChanges.code === SUSPEND_CONSTANTS.RETENTION_SUSPEND)) {
        this.approverType = '';
        this.startDate = '';
        this.endDate = '';
        this.minimumEndDate = this.startDate;
      }
      for (const line of this.suspendendeLines) {
        this.renderingSuspendApplyAllorSingleField(line,checkingApplyAllField);
        this.checkingMaxDate(line);
      }
    } else {
      this.resettingAllValues();
    }
  }
  renderingSuspendApplyAllorSingleField(line,checkingApplyAllField){
    if (checkingApplyAllField) {
      line.reasonForChanges = this.reasonForChanges;
      line.approverType = this.approverType;
      line.reasonForChange = new UntypedFormControl(this.reasonForChanges.description);
      line.lineApproverType = new UntypedFormControl(this.approverType.description);
      line.approverTypeList = this.approverTypeList;
      line.startDate = this.startDate;
      line.endDate = this.endDate;
      line.msgShowOnPanel = true;
      this.setMessageForPanel(line);
      const approvercode = !isNullOrUndefined(this.approverType && this.approverType.code) ? this.approverType.code : '';
      this.getSuspensionEligibility(line, this.reasonForChanges.code, approvercode);
    } else {
      this.termsAndConditionCheckBox = false;
      line.msgShowOnPanel = false;
      line.succesValidator = false;
      line.errorValidator = false;
      line.reasonForChanges = this.reasonForChanges;
      line.approverType = this.approverType;
      line.reasonForChange = new UntypedFormControl(this.reasonForChanges.description);
      line.lineApproverType = new UntypedFormControl(this.approverType.description);
      line.startDate = this.startDate;
      line.endDate = this.endDate;
      line.susEligibilityerroeInline = '';
      line.resonErrorInline = '';
      line.aproverErrorInline = '';
      line.description = new UntypedFormControl(this.reasonForChanges.description);
      line.aproverType = new UntypedFormControl(this.approverType.description);
    }
    if (!isNullOrUndefined(this.startDate) && this.endDate === '' && this.startDate !== '') {
      this.suspendCheckingMaxDateValidation(line);
    }
  }
  resettingAllValues() {
    this.counter = 0;
    if (!isNullOrUndefined(this.suspendendeLines) && this.suspendendeLines.length !== 0) {
      for (const line of this.suspendendeLines) {
        line.msgShowOnPanel = false;
        line.succesValidator = false;
        line.errorValidator = false;
        line.reasonForChanges = '';
        line.approverType = '';
        line.reasonForChange = new UntypedFormControl('');
        line.lineApproverType = new UntypedFormControl('');
        line.startDate = '';
        line.endDate = '';
        this.termsAndConditionCheckBox = false;
        line.susEligibilityerroeInline = '';
        line.resonErrorInline = '';
        line.aproverErrorInline = '';
        this.selectsubmitCheckBox = false;
        this.tncCheckBox = true;
        line.reasonForChange = new UntypedFormControl('');
        line.lineApproverType = new UntypedFormControl('');
      }
    }
  }

  // while one line selected
  oneLineEndDateSelected() {
    this.isOneLine = true;
    if (this.checkingAllFieldCondition()) {
      this.IndividualLine = this.suspendendeLines[0];
      this.IndividualLine.startDate = this.startDate;
      this.IndividualLine.endDate = this.endDate;
      this.getSuspensionEligibility(this.IndividualLine, this.reasonForChanges.code, this.approverType.code);
    } else {
      this.termsAndConditionCheckBox = false;
    }
  }

  oneLineStartDateSelected(reasonCode, approverTypeCode) {
    this.endDate = '';
    this.minimumEndDate = this.startDate;
    this.applyToAll =false;
    if (!isNullOrUndefined(this.reasonForChanges && this.reasonForChanges.code && this.startDate)) {
      let dtStartDate: Date = new Date(this.startDate.year, this.startDate.month - 1, this.startDate.day);
      const endDays = this.getEndDaysFromReasonCodeAndApproverType(reasonCode, approverTypeCode)
      const dateToSet_EndDate = new Date(dtStartDate.setDate(dtStartDate.getDate() + Number(endDays)));
      this.maxDate = {
        year: dateToSet_EndDate.getFullYear(), month: dateToSet_EndDate.getMonth() + COMMON_CONSTANTS.DIGITS.ONE,
        day: dateToSet_EndDate.getDate()
      };

      if (!this.isSingleFlow && !isNullOrUndefined(this.applyToAll) && this.applyToAll) {
        this.applyToAllCheckBox();
      }
    }
    const newdate1 = this.datePipe.transform(new Date(this.startDate.year, this.startDate.month - COMMON_CONSTANTS.DIGITS.ONE, this.startDate.day
      + COMMON_CONSTANTS.DIGITS.ONE),
      MANAGE_MODAL_CONST.DATE_FORMAT_FOR_CALL);
    this.minimumEndDate = {
      year: Number(newdate1.split('-')[0]), month: Number(newdate1.split('-')[1]),
      day: Number(newdate1.split('-')[2])
    };
    if (!this.isSingleFlow && !isNullOrUndefined(this.applyToAll) && this.applyToAll) {
      this.applyToAllCheckBox();
    }
    this.disableApplyToAll = true;

    if (this.isSingleFlow && !isNullOrUndefined(this.reasonForChanges && this.reasonForChanges.code && this.startDate) && this.reasonForChanges.code === MANAGE_LINE_CONST.SUNC) {
      this.suncFlowOptionalEndDate();

    }else if(!this.isSingleFlow && !isNullOrUndefined(this.reasonForChanges && this.reasonForChanges.code && this.startDate) && this.reasonForChanges.code === MANAGE_LINE_CONST.SUNC) {
      this.disableApplyToAll = false;
      this.applyToAllCheckBox();
    }
  }
  suncFlowOptionalEndDate(){
    this.isOneLine = true;
    if (!isNullOrUndefined(this.reasonForChanges) && !isNullOrUndefined(this.approverType) &&
    !isNullOrUndefined(this.startDate) && this.reasonForChanges.code === MANAGE_LINE_CONST.SUNC) {
      this.IndividualLine = this.suspendendeLines[0];
      this.IndividualLine.startDate = this.startDate;
      this.IndividualLine.endDate = this.endDate;
      this.getSuspensionEligibility(this.IndividualLine, this.reasonForChanges.code, this.approverType.code);
    } else {
      this.termsAndConditionCheckBox = false;
    }
  }

  multipleStartDate(line) {
    this.applyToAll = false;
    this.suspendCheckingMaxDateValidation(line);
    if(!this.isSingleFlow && line.endDate == '' && line.reasonForChanges.code == MANAGE_LINE_CONST.SUNC){
      this.applyToAll = false;
      this.setMessageForPanel(line);
      this.getSuspensionEligibility(line, line.reasonForChanges.code, line.approverType.code);
    }

  }

  suspendCheckingMaxDateValidation(line) {
    if (!isNullOrUndefined(line && line.startDate && line.reasonForChanges)) {
      let dtStartDate: Date = new Date(line.startDate.year, line.startDate.month - 1, line.startDate.day);
      const endDays = this.getEndDaysFromReasonCodeAndApproverType(line.reasonForChanges.code, line.approverType);
      const dateToSet_EndDate = new Date(dtStartDate.setDate(dtStartDate.getDate() + Number(endDays)));
      line.endMinDate = {
        year: line.startDate.year, month: line.startDate.month,
        day: line.startDate.day + COMMON_CONSTANTS.DIGITS.ONE
      };
      line.maxDate = {
        year: dateToSet_EndDate.getFullYear(), month: dateToSet_EndDate.getMonth() + COMMON_CONSTANTS.DIGITS.ONE,
        day: dateToSet_EndDate.getDate()
      };
    }

  }

  submitButtonClicked() {
    this.pdlService.ifEnabledGenerateClickTag({
      type: ANALYTICS.CLICK_TO_NAVIGATE,
      action: ANALYTICS.CLICK,
      ctaName: ANALYTICS.SUBMIT_CHANGE,
      assetType: ANALYTICS.BUTTON,
      modalName: ANALYTICS.SUSPEND_MODAL_NAME,
      userSelection: this.reasonForChanges?.description
    });
    this._loaderSvc.start();
    this.ngbModalOptions = {
      container: '#am-container-custom',
    };
    if (this.utilsSvc.IsEndUser() && environment.ENABLE_AHUB_FLOW) {
      this.approvalActivitiesList = JSON.parse(this._cacheSvc.getFromSessionStorage('approvalFlags'));
      if (!isNullOrUndefined(this.approvalActivitiesList)) {
        for(let approval of this.approvalActivitiesList) {
          if (approval.FlagName === COMMON_CONSTANTS.IS_SUSPEND_APPROVAL) {
            this.isApprovalRequired = approval.FlagValue;
          }
        }
      }
    }
    this.requestHeaders = this.setRequestHeaders();
    if (this.isSingleFlow) {
      this.serviceSuspensionSingleFlow();
    } else {
      this.serviceSuspensionBulkFlow();
    }
  }

  serviceSuspensionSingleFlow() {
    this.manageLineService.serviceSuspension(this.requestHeaders).subscribe(response => {
      this._loaderSvc.stop();
      if (!isNullOrUndefined(response) && !isNullOrUndefined(response.status)
        && response.status === SUSPEND_CONSTANTS.SUCCESS) {
          if (this.utilsSvc.IsEndUser() && this.isApprovalRequired === COMMON_CONSTANTS.DIGITS.ONE) {
            this.openEndUserSuccessModal(response);
          } else {
            this.results = response;
            this.manageLineService.close();
            const successModalRef = this.modalService.open(SuccessComponent, this.ngbModalOptions);
            successModalRef.componentInstance.token = response.accountTransactionRefNum;
            successModalRef.componentInstance.header = this.authoringContentData.manageLine.suspensdRequestComplete;
            successModalRef.componentInstance.isLineDetailsWindow = this.isLineDetailsWindow;
          }
      } else {
        const err = SUSPEND_CONSTANTS.SUSPEND_ERROR;
        this.utilsSvc.errorHandling(err);
      }
    }, err => {
      this.errorThrown(err);
    });
  }

  serviceSuspensionBulkFlow() {
    this.manageLineService.bulkSuspend(this.requestHeaders).subscribe(response => {
      this._loaderSvc.stop();
      if (!isNullOrUndefined(response) && !isNullOrUndefined(response.status)
        && response.status === SUSPEND_CONSTANTS.SUCCESS) {
        this.results = response;
        this.manageLineService.close();
        const successModalRef = this.modalService.open(SuccessComponent, this.ngbModalOptions);
        successModalRef.componentInstance.token = response.token;
        successModalRef.componentInstance.header = this.authoringContentData.manageLine.suspensdRequestComplete;
      } else {
        const err = SUSPEND_CONSTANTS.SUSPEND_ERROR;
        this.utilsSvc.errorHandling(err);
      }
    }, err => {
      this.errorThrown(err);
    });
  }

  errorThrown(err) {
    this._loaderSvc.stop();
    this.utilsSvc.errorHandling(err);
  }

  getSuspendedReasons() {
    this.manageLineService.suspendReasons().subscribe(reasons => {
      if (!isNullOrUndefined(reasons) && !isNullOrUndefined(reasons.suspendReasons)) {
          reasons.suspendReasons = reasons.suspendReasons.filter(a => (a.code != MANAGE_LINE_CONST.EDUS));
        if (!this.isAmOktaEnabled && !isNullOrUndefined(reasons.suspendReasons)) {
          reasons.suspendReasons = reasons.suspendReasons.filter(a => (a.code == MANAGE_LINE_CONST.ELST) || (a.code == MANAGE_LINE_CONST.SSQ));
        }
        this.reasons = reasons.suspendReasons;
        const index = this.reasons.findIndex(item => item.code === MANAGE_LINE_CONST.MSS);
        if (!isNullOrUndefined(index) && index > COMMON_CONSTANTS.DIGITS.MINUS_ONE) {
          this.reasons.splice(index, COMMON_CONSTANTS.DIGITS.ONE);
        }
      }
    }, err => {
      this.resonErrorInline = !isNullOrUndefined(err.message) ? err.message : COMMON_CONSTANTS.SERVER_ERROR_MESSAGE;
    });
  }
  downloadSuspendValidatedData() {
    ContentService.SetCache(BULK_UPLOAD.BULK_FLOW_KEY, BULK_UPLOAD.SUSPEND_KEY);
    let multiLinejsonData = this.setRequestHeaders();
    let multiLineSuccessData = multiLinejsonData.requests;
    let temp;
    if (!isNullOrUndefined(multiLineSuccessData)) {
      const suspendTemplate = [];
      for(let line of multiLineSuccessData) {
        if (line) {
          temp = this.getSuspendValidatedData(line);
          suspendTemplate.push(temp);
        }
      }
      this.exportSvc.exportAsExcelFile(suspendTemplate, BULK_UPLOAD.SUSPEND_SUCCESS_DOWNLOAD);
    }
  }

  getSuspendValidatedData(line) {
    const temp = {};
    temp[BULK_UPLOAD.BULK_PHONE_NUMBER_TXT] = !isNullOrUndefined(line.msisdn) ? Number(line.msisdn) : '';
    temp[BULK_UPLOAD.BULK_SUSPEND_REASON_TXT] = !isNullOrUndefined(line.reasonCode) ? this.getSuspendReasonCode(line.reasonCode) : '';
    temp[BULK_UPLOAD.BULK_SUSPEND_APPROVER_TXT] = !isNullOrUndefined(line.validatorType) ? line.validatorType : '';
    temp[BULK_UPLOAD.BULK_SUSPEND_STARTDATE_TXT] = !isNullOrUndefined(line.suspendStartDate) ? this.transformDate(line.suspendStartDate) : '';
    temp[BULK_UPLOAD.BULK_SUSPEND_ENDDATE_TXT] = !isNullOrUndefined(line.restoreDate) ? this.transformDate(line.restoreDate) : '';
    return temp;
  }

  getSuspendReasonCode(reasonCode) {
    switch (reasonCode) {
      case SUSPEND_CONSTANTS.TEMP_SUSPEND:
        return SUSPEND_CONSTANTS.TEMP_SUSPEND_TXT;
      case SUSPEND_CONSTANTS.SUSPEND_WITHOUT_CHARGES:
        return SUSPEND_CONSTANTS.SUSPEND_WITHOUT_CHARGES_TXT;
      case SUSPEND_CONSTANTS.SUSPEND_WITH_CHARGES:
        return SUSPEND_CONSTANTS.SUSPEND_WITH_CHARGES_TXT;
      case SUSPEND_CONSTANTS.LOST_STOLEN_SUSPEND:
        return SUSPEND_CONSTANTS.LOST_STOLEN_SUSPEND_TXT;
      case SUSPEND_CONSTANTS.SEASONAL_SUSPEND:
        return SUSPEND_CONSTANTS.SEASONAL_SUSPEND_TXT;
      case SUSPEND_CONSTANTS.MILTARY_SUSPEND:
        return SUSPEND_CONSTANTS.MILTARY_SUSPEND_TXT;
      case SUSPEND_CONSTANTS.EDUCATION_SUMMER_SUSPEND:
        return SUSPEND_CONSTANTS.EDUCATION_SUMMER_SUSPEND_TXT;
      case SUSPEND_CONSTANTS.IMPLEMENTATION_SUSPEND:
        return SUSPEND_CONSTANTS.IMPLEMENTATION_SUSPEND_TXT;
      case SUSPEND_CONSTANTS.MCSA_CONTRACTUAL_SUSPEND:
        return SUSPEND_CONSTANTS.MCSA_CONTRACTUAL_SUSPEND_TXT;
      case SUSPEND_CONSTANTS.SUNC_SUSPEND:
        return SUSPEND_CONSTANTS.SUNC_SUSPEND_TXT;
      case SUSPEND_CONSTANTS.RETENTION_SUSPEND:
        return SUSPEND_CONSTANTS.RETENTION_SUSPEND_UNDERSCORE_TXT;
    }
  }
  transformDate(date: string) {
    let formatedDate = '';
    if (!isNullOrUndefined(date)) {
      const splitDate = date.split(COMMON_CONSTANTS.SYMBOLS.DASH);
      if(splitDate.length === VALUE.THREE) {
        formatedDate = splitDate[VALUE.ONE] + COMMON_CONSTANTS.SYMBOLS.FORWARD_SLASH +
                       splitDate[VALUE.TWO] + COMMON_CONSTANTS.SYMBOLS.FORWARD_SLASH +
                       splitDate[VALUE.ZERO];
      } else {
        formatedDate =  date;
      }
    }
    return formatedDate;
  }
  getSuspendedApprovalTypes(reason) {
    this.isLoaderOn = true;
    if (!isNullOrUndefined(reason) && !isNullOrUndefined(reason.code)) {
      this.manageLineService.suspendApprovalTypes(reason.code).subscribe(approvalTypes => {
        this.isLoaderOn = false;
        if (!isNullOrUndefined(approvalTypes && approvalTypes.approverTypes) && approvalTypes.status == SUSPEND_CONSTANTS.SUCCESS) {
          this.approverTypeList = approvalTypes.approverTypes;
          this.approverType = approvalTypes.approverTypes[0];
          this.selectedReason = this.approverType.description;
          this.lineApproverType = new UntypedFormControl(this.approverType.description);
        } else {
          this.approverTypeList = [];
          this.approverType = '';
        }
      }, err => {
        this.isLoaderOn = false;
        this.aproverErrorInline = !isNullOrUndefined(err.message) ? err.message : COMMON_CONSTANTS.SERVER_ERROR_MESSAGE;
      });
    }
  }

  getSuspensionEligibility(line, reasonCode, approverType) {
    this.isLoaderOn = true;
    let request: any = {};
    line.suspendStartDate = '';
    if (!isNullOrUndefined(line) && !isNullOrUndefined(line.startDate) && line.startDate !== '') {
      line.suspendStartDate = this.datePipe.transform(new Date(line.startDate.year, line.startDate.month - 1, line.startDate.day),
        MANAGE_MODAL_CONST.DATE_FORMAT_FOR_CALL);
    }

    line.restoreDate = '';
    if (!isNullOrUndefined(line) && !isNullOrUndefined(line.endDate) && line.endDate !== '') {
      line.restoreDate = this.datePipe.transform(new Date(line.endDate.year, line.endDate.month - 1, line.endDate.day),
        MANAGE_MODAL_CONST.DATE_FORMAT_FOR_CALL);
    }

    request.reasonCode = !isNullOrUndefined(reasonCode) ? reasonCode : '';
    request.validatorType = !isNullOrUndefined(approverType) ? approverType : '';
    request.suspendStartDate = line.suspendStartDate;
    request.mobileNumber = !isNullOrUndefined(line && line.msisdn) ? line.msisdn : '';
    request.restoreDate = line.restoreDate;

    /**
     * If reason code is RETN do not send an empty string for suspendStartDate
     * like we do for ELST but give actual 'today' date
     *
     * ex - 2022-11-30
     */
     if (reasonCode == SUSPEND_CONSTANTS.RETENTION_SUSPEND) {
      let suspendDate = new Date(this.PSTDate[0].year, this.PSTDate[0].month - 1, this.PSTDate[0].day).toDateString();
      if (this.minimumDate) {
        suspendDate = this.minimumDate?.year + "-" + this.minimumDate?.month + "-" + this.minimumDate?.day;
      }
      request.suspendStartDate = this.datePipe.transform(suspendDate, MANAGE_MODAL_CONST.DATE_FORMAT_FOR_CALL);
    }

    this.suspensionEligibility(request, line);
  }

  suspensionEligibility(request, line) {
    this.tncCheckBox = true;
    this.manageLineService.suspensionEligibility(request).subscribe(response => {
      this.isLoaderOn = false;
      this.counter++;
      if (!isNullOrUndefined(response) && response.status === SUSPEND_CONSTANTS.SUCCESS) {
        this.suspensionEligibilityReqSuccess(response, line);
        this.validateTncCheckbox();
      } else {
        this.suspensionEligibilityReqErr(response, line);
      }
    }, err => {
      this.suspensionEligibilityHttpErr(err, line);
    });
  }

  suspensionEligibilityReqErr(response, line) {

    line.tncCheckboxDisable = true;
    this.termsAndConditionCheckBox = false;
    if (this.isOneLine) {
      this.susEligibilityerroeInline = !isNullOrUndefined(response.message) ? response.message : COMMON_CONSTANTS.SERVER_ERROR_MESSAGE;
    } else {
      line.susEligibilityerroeInline = !isNullOrUndefined(response.message) ? response.message : COMMON_CONSTANTS.SERVER_ERROR_MESSAGE;
    }
    line.succesValidator = false;
    line.errorValidator = true;
    this.termsAndConditionCheckBox = false;
    this.suspendCheckingMaxDateValidation(line);
  }

  suspensionEligibilityReqSuccess(response, line) {
    this.results = response;
    if (this.isOneLine) {
      this.susEligibilityerroeInline = '';
    } else {
      line.susEligibilityerroeInline = '';
    }
    this.ban = response.ban;
    line.tncCheckboxDisable = false;
    line.succesValidator = true;
    line.errorValidator = false;
    this.dealerCode = !isNullOrUndefined(response.dealerCode) ? response.dealerCode : '';
    this.multipleLineCounterSuccess++;
    if (this.isOneLine) {
      this.termsAndConditionCheckBox = true;
    } else if (!isNullOrUndefined(this.suspendendeLines) && this.multipleLineCounterSuccess === this.suspendendeLines.length) {
      this.termsAndConditionCheckBox = true;
    } else {
      this.termsAndConditionCheckBox = false;
    }

    this.disableApplyToAll = false;
    if(!isNullOrUndefined(line && line.startDate)){
      line.endMinDate = {
        year: line.startDate.year, month: line.startDate.month,
        day: line.startDate.day + COMMON_CONSTANTS.DIGITS.ONE
      };
    }
    this.suspendCheckingMaxDateValidation(line);
  }

  suspensionEligibilityHttpErr(err, line) {
    this.counter++;
    line.tncCheckboxDisable = true;
    this.isLoaderOn = false;
    this.validateTncCheckbox();
    if (this.isOneLine) {
      this.susEligibilityerroeInline = !isNullOrUndefined(err.message) ? err.message : COMMON_CONSTANTS.SERVER_ERROR_MESSAGE;
    } else {
      line.susEligibilityerroeInline = !isNullOrUndefined(err.message) ? err.message : COMMON_CONSTANTS.SERVER_ERROR_MESSAGE;
    }
    line.succesValidator = false;
    line.errorValidator = true;
    this.termsAndConditionCheckBox = false;
  }

  getRequestHeadersSingleFlow(authInfo) {
    const element = this.suspendendeLines[0];
    this.individualLineHeaders.ban = this.ban;
    this.individualLineHeaders.reasonCode = this.reasonForChanges.code;
    if (!isNullOrUndefined(element) && !isNullOrUndefined(element.suspendStartDate) &&
      element.suspendStartDate !== '') {
      this.individualLineHeaders.suspendStartDate = element.suspendStartDate;
    } else {
      this.individualLineHeaders.suspendStartDate = this.datePipe.transform(new Date(this.PSTDate[0].year, this.PSTDate[0].month - 1, this.PSTDate[0].day), MANAGE_MODAL_CONST.DATE_FORMAT_FOR_CALL);
    }
    this.individualLineHeaders.restoreDate = element.restoreDate;
    this.individualLineHeaders.extendContract = null;
    this.individualLineHeaders.validatorType = !isNullOrUndefined(this.approverType && this.approverType.code) ?
    this.approverType.code : '';
    this.individualLineHeaders.logonId = !isNullOrUndefined(authInfo) ? authInfo.logonID : COMMON_CONSTANTS.LOGON_ID;
    this.individualLineHeaders.email = !isNullOrUndefined(authInfo) ? authInfo.logonEmail : COMMON_CONSTANTS.LOGON_ID;
    this.individualLineHeaders.dealerCode = this.dealerCode;
    this.individualLineHeaders.mobileNumber = !isNullOrUndefined(element.msisdn) ? element.msisdn : '';
    return this.individualLineHeaders;
  }

  getRequestHeadersMultiFlow(authInfo) {
    this.multiLineHeaders.requests = [];
    this.multiLineHeaders.ban = this._cacheSvc.getFromSessionStorage(MANAGE_LINE_CONST.BAN);
    this.multiLineHeaders.targetServiceName = SUSPEND_CONSTANTS.SUSPEND_SERVICE;
    for (let line of this.suspendendeLines) {
      const requests = new Requests();
      requests.orgId = this._helperUtilSvc.getOrgID();
      requests.msisdn = line.msisdn;
      requests.reasonCode = line.reasonForChanges.code;
      requests.suspendStartDate = line.suspendStartDate;
      if (!isNullOrUndefined(line) && !isNullOrUndefined(line.suspendStartDate) &&
        line.suspendStartDate !== '') {
        requests.suspendStartDate = line.suspendStartDate;
      } else {
        requests.suspendStartDate = this.datePipe.transform(new Date(this.PSTDate[0].year, this.PSTDate[0].month - 1, this.PSTDate[0].day), MANAGE_MODAL_CONST.DATE_FORMAT_FOR_CALL);
      }

      requests.restoreDate = line.restoreDate;
      requests.extendContract = true;
      requests.logonId = !isNullOrUndefined(authInfo) ? authInfo.logonID : COMMON_CONSTANTS.LOGON_ID;
      requests.email = !isNullOrUndefined(authInfo) ? authInfo.logonEmail : COMMON_CONSTANTS.LOGON_ID;
      requests.dealerCode = this.dealerCode;
      this.individualLineHeaders.mobileNumber = line?.msisdn || "";
      requests.validatorType = !isNullOrUndefined(line.approverType && line.approverType.code) ? line.approverType.code : '';
      this.multiLineHeaders.requests.push(requests);
    }
    return this.multiLineHeaders;
  }

  setRequestHeaders() {
    const authInfo = JSON.parse(this._cacheSvc.getFromSessionStorage(MANAGE_LINE_CONST.AUTHENTICATION_INFO));
    let request: any = [];
    if (this.isSingleFlow) {
      request = this.getRequestHeadersSingleFlow(authInfo);
    } else {
      request = this.getRequestHeadersMultiFlow(authInfo);
    }
    return request;
  }

  closeSuspendModal() {
    this.pdlService.ifEnabledGenerateClickTag({
      type: ANALYTICS.CLICK_TO_NAVIGATE,
      action: ANALYTICS.CLICK,
      ctaName: ANALYTICS.CLOSE,
      assetType: ANALYTICS.BUTTON,
      modalName: ANALYTICS.SUSPEND_MODAL_NAME
    });
    this.manageLineService.close();
    this.manageLineService.changeCurrentSelection(SUSPEND_CONSTANTS.CLOSE_SUSPEND_MODAL);
  }

  onFocusDate() {
    this.datePicker.open();
  }
  onBlurDate() {
    this.datePicker.close();
  }

  onApplySelectngx(evt) {
    this.ngxdp.hide();
  }

  validateTncCheckbox() {
    this.tncCheckBox = false;
    this.selectsubmitCheckBox = false;
    if (!isNullOrUndefined(this.suspendendeLines)) {
      for (const element of this.suspendendeLines) {
        if (!isNullOrUndefined(element) && (element.tncCheckboxDisable || !element.succesValidator)) {
          this.tncCheckBox = true;
          this.selectsubmitCheckBox = false;
          break;
        }
      }
    }
  }

  nextStep(line) {
    const nextIndex = this.suspendendeLines.findIndex(item => item.msisdn === line.msisdn);
    if (this.suspendendeLines.length -1 > nextIndex) {
      this.suspendendeLines[nextIndex + 1].expendFlagValue = true;
    }
    this.suspendendeLines[nextIndex].expendFlagValue = false;
  }

  openEndUserSuccessModal(response) {
    this.manageLineService.close();
    const successModalRef = this.modalService.open(SuccessComponent);
    successModalRef.componentInstance.orderStatus = response.accountTransactionRefNum;
    successModalRef.componentInstance.header = this.authoringContentData.suspend.approvalPopupHeader;
    successModalRef.componentInstance.isConfirmationPopup = true;
    successModalRef.componentInstance.processText = this.authoringContentData.suspend.approvalPopupProcessText;
    successModalRef.componentInstance.isSuspend = true;
    successModalRef.componentInstance.modalBodyContent = this.authoringContentData.suspend.approvalModalBodyText;
  }

  getUniqueReasonsSelected() {
    this.uniqueReasonsSelected = [];
    if (this.suspendendeLines?.length > 0) {
      const uniqueLinesByReason: any = [...new Map(this.suspendendeLines.map(line => [line.reasonForChanges.code, line])).values()];
      for (const line of uniqueLinesByReason) {
        this.uniqueReasonsSelected.push({code: line.reasonForChanges.code, description: line.reasonForChanges.description});
      }
    }
  }
}
